// --- 票券管理 --- //

export default [
  {
    name: 'ticketsManagement',
    path: '/carWashSuperviseSystem/:carWashId/ticketsManagement',
    meta: { title: '票券管理' },
    component: require('business/carWashSuperviseSystem/ticketsManagement/list.vue').default
  }
]
